import * as ko from 'knockout';
import * as localisationHelper from 'localisationHelper';
import 'knockoutCustomBindings';
import { RegistrationService } from 'Content/ts/Account/Services/registrationService';

import { LinkRegistrationModelKo } from 'Content/ts/Models/Account/LinkRegistrationModel';
import { RegistrationResultModel } from 'Content/ts/Models/Account/RegistrationResultModel';
import { LinkRegistrationModelKoValidated } from 'Content/ts/Models/Account/Validation/LinkRegistrationModelKoValidated';

export default class RegisterVM {
    loading: KnockoutObservable<boolean>;
    displayTermsAndConditions: KnockoutObservable<boolean>;
    displayRegistration: KnockoutObservable<boolean>;
    termsConditionsAccepted: KnockoutObservable<boolean>;
    registrationResult: KnockoutObservable<boolean>;
    registrationError: KnockoutObservable<string>;
    registrationDetails: KnockoutObservable<LinkRegistrationModelKoValidated>;
    openingTerms: boolean;

    constructor() {        
        this.loading = ko.observable(true);
        this.displayTermsAndConditions = ko.observable(false);
        this.displayRegistration = ko.observable(false);
        this.termsConditionsAccepted = ko.observable(false);
        this.openingTerms = false;
        this.registrationResult = ko.observable(false);
        this.registrationError = ko.observable(null);
        this.registrationDetails = ko.observable(new LinkRegistrationModelKoValidated());
        this.setupSubscribes();
        this.loading(false);

        if (/[?&]registerandlink=true/.test(location.search.toLowerCase())) {
            this.displayRegistration(true);
        }
    }

    register() {
        this.registrationError(null);
        this.loading(true);

        if (this.formValid()) {
            RegistrationService.register(this.registrationDetails() as LinkRegistrationModelKo).then((result: RegistrationResultModel) => {
                this.registrationResult(result.Success);
                this.registrationError(result.ErrorMessage);
                this.loading(false);
            }).fail(() => {
                this.loading(false);
                this.registrationError(localisationHelper.getString('AccountManagement', 'RegistrationFailedErrorMessage'));
            });
        } else {
            this.registrationDetails().validationErrors.showAllMessages();
            this.loading(false);
        }
    }

    private setupSubscribes() {
        this.displayRegistration.subscribe((value) => {
            if (!value && !this.openingTerms) {
                this.reset();
            }
        });
    }

    private reset() {
        this.displayTermsAndConditions(false);
        this.loading(false);
        this.termsConditionsAccepted(false);
        this.registrationResult(false);
        this.registrationError(null);
        this.registrationDetails(new LinkRegistrationModelKoValidated());
    }

    toggleModal() {
        this.displayRegistration(!this.displayRegistration());
    }

    openTermsAndConditions() {
        this.openingTerms = true;
        this.displayRegistration(false);
        this.displayTermsAndConditions(true);
    }

    closeTermsAndConditions(accepted: boolean) {
        this.openingTerms = false;
        this.termsConditionsAccepted(accepted);
        this.displayTermsAndConditions(false);
        this.displayRegistration(true);
    }

    formValid() {
        return this.registrationDetails().isValid() && this.termsConditionsAccepted()
            && !this.registrationDetails().Password.isValidating();
    }
}

ko.components.unregister('register');
ko.components.register('register', {
    viewModel: RegisterVM,
    template: { require: 'text!/Themes/Default/Content/ts/Account/register.html' }
});